import { render, staticRenderFns } from "./SmallCard.vue?vue&type=template&id=2a2c8502&scoped=true"
import script from "./SmallCard.vue?vue&type=script&lang=js"
export * from "./SmallCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2c8502",
  null
  
)

export default component.exports